(function ($) {
  let isTriggered = false;

  $('.js-register').on('click', function (e) {
    const $field = $('#reg_email');
    const email = $field.val();

    // // Reset message alert
    $('.parsley-errors-list').hide();
    $('.parsley-errors-list').css('position', 'absolute');

    if (!isTriggered) {
      e.preventDefault();
      if (email != '') {
        if (!validateEmail(email)) {
          $('.wrong-email').css('position', 'relative');
          $('.wrong-email').show();
          $field.addClass('parsley-error');
          return;
        }

        if ($('.password-is-strong').length == 0) {
          $field.addClass('parsley-error');
          $('.popover-password').addClass('popover-password--show');
          return;
        }

        $.ajax({
          type: 'POST',
          dataType: 'json',
          url: window.wp.ajax.settings.url,
          data: {
            action: 'check_email_exist',
            email,
          },
          success(response) {
            if (!response.data) {
              $field.removeClass('parsley-error');
              sessionStorage.setItem('email_new_account', email);
              isTriggered = true;
              $('.js-register').trigger('click');
            } else {
              $field.addClass('parsley-error');
              $('.existing-email').css('position', 'relative');
              $('.existing-email').show();
            }
          },
        });
      } else {
        $field.addClass('parsley-error');
        $('.required-email').css('position', 'relative');
        $('.required-email').show();
      }
    }
  });

  /**
   * Check email validity
   * @param  {string} email Value from email field
   * @returns {boolean}
   */
  function validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
})(jQuery);
